/**
 * Formats shipment type by replacing abbreviations with full words
 * @param shipmentType - The shipment type string (e.g., 'D', 'L', or already formatted)
 * @returns Formatted shipment type ('Drop', 'Live', or original string)
 */
export const formatShipmentType = (shipmentType: string | undefined | null): string => {
  if (!shipmentType) return '';
  
  return shipmentType
    .replace(/\bD\b/g, 'Drop')
    .replace(/\bL\b/g, 'Live');
};

/**
 * Formats direction by capitalizing the first letter for display
 * @param direction - The direction string (e.g., 'inbound', 'outbound')
 * @returns Formatted direction ('Inbound', 'Outbound', or empty string)
 */
export const formatDirection = (direction: string | undefined | null): string => {
  if (!direction) return '';
  
  return direction.charAt(0).toUpperCase() + direction.slice(1).toLowerCase();
};
